import { useMutation } from "@tanstack/react-query";
import { updateGeneralAssistant } from "../api/updateGeneralAssistant";

export const useUpdateGeneralAssistantMutation = () => {
  return useMutation({
    mutationFn: async (params: {
      languageName: string;
      assistantId: string;
    }) => {
      const response = await updateGeneralAssistant(
        params.languageName,
        params.assistantId,
      );
      return response;
    },
  });
};
